function formatDaysAgo(days: number): string {
  const rounded = Math.round(days);
  return rounded === 1 ? '1 day ago' : `${rounded} days ago`;
}

export function formatStaleness(lastKnownAt: number, now = Date.now()): string {
  const ageMs = now - lastKnownAt;
  if (ageMs < 15_000) {
    return 'now';
  }
  if (ageMs < 60_000) {
    return `${Math.floor(ageMs / 1000)} sec ago`;
  }
  if (ageMs < 3_600_000) {
    return `${Math.floor(ageMs / 60_000)} min ago`;
  }
  if (ageMs < 86_400_000) {
    return `${Math.floor(ageMs / 3_600_000)} hr ago`;
  }
  return new Date(lastKnownAt).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatStalenessShort(lastKnownAt: number, now = Date.now()): string {
  const ageMinutes = (now - lastKnownAt) / 60_000;
  const ageHours = ageMinutes / 60;
  const ageDays = ageHours / 24;
  if (ageMinutes < 1) {
    return 'now';
  }
  if (ageMinutes < 60) {
    return `${Math.round(ageMinutes)} min ago`;
  }
  if (ageHours < 24) {
    return `${Math.round(ageHours)} hr ago`;
  }
  if (ageDays < 7) {
    return formatDaysAgo(ageDays);
  }
  return new Date(lastKnownAt).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}
